import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  EnvironmentConfigService,
  Environment,
  PlatformServiceName
} from '@ot/shared/utils';
import { ENVIRONMENT } from '@ot/shared/model';
import { map } from 'rxjs/operators';
import { map as _map, sortBy } from 'lodash';

export const USER_PROFILE_KEY = 'user_profile';

@Component({
  selector: 'ot-baid-picker',
  templateUrl: './baid-picker.component.html',
  styleUrls: ['./baid-picker.component.scss']
})
export class BaidPickerComponent implements OnInit {
  baidOptions$: Observable<Object[]>;
  selectedBaid: string;
  apiUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT) private environment: Environment,
    private environmentConfigService: EnvironmentConfigService
  ) {}

  // TODO HACK don't do ANY of this.
  ngOnInit() {
    if (localStorage.getItem('selectedBaid')) {
      const initBaid = localStorage.getItem('selectedBaid');
      this.selectedBaid = initBaid;
    }
    this.apiUrl =
      this.environmentConfigService.getEnvironmentConfigs().apis.platform.url +
      '/' +
      this.environment.serviceUrlList[
        PlatformServiceName.BusinessAccountService
      ];

    this.baidOptions$ = this.http
      .get<ListBusinessAccountsResponse>(
        this.apiUrl +
          '/listBusinessAcctPagination?options.page_token=1&options.page_size=500',
        { observe: 'response' }
      )
      .pipe(
        map((response: HttpResponse<ListBusinessAccountsResponse>) => {
          return response.body.businessAccts;
        }),
        map(businessAccounts => {
          return sortBy(businessAccounts, ['businessAcctObj.accountName']);
        })
      );
  }

  baidSelect() {
    console.log('selected: ', this.selectedBaid);
    localStorage.setItem('selectedBaid', this.selectedBaid);
  }
}

class ListBusinessAccountsResponse {
  businessAccts: object[];
  totalCount: string;
  totalPages: string;
  nextPageToken: string;
}
